import styled from 'styled-components';
import Screen from '@/styles/Themes/Screen';
import { borders, paddings, radius } from '@/styles/Themes/Metrics';
import Palette from '@/styles/Themes/Palette';

export const ButtonWrapper = styled.div`
    width: 100%;
    margin: 20px 0;

    ${Screen.ipad} {
        margin: 30px 0 20px;
    }

    ${Screen.desktop} {
        padding: 5% 80px 5% 10px;
        float: right;
        vertical-align: middle;
        width: 50%;
        > button {
            background-color: transparent;
        }
    }
`;

export const Button = styled.a`
    display: block;
    color: inherit;
    text-decoration: none;
    cursor: pointer;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-grow: 1;

    background: ${Palette.gradient.light};
    color: ${Palette.white.normal};

    border-radius: ${radius.button};
    padding: ${paddings.medium};
    border: ${borders.small} ${Palette.green.normal};

    &:hover {
        background: ${Palette.gradient.dark};
        text-decoration: none;
    }

    > span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`;
